// extracted by mini-css-extract-plugin
export var cardGrid = "ArticleGridSection-module--cardGrid--0c0d5";
export var content = "ArticleGridSection-module--content--dfd89";